module.exports = __webpack_public_path__ + "img/dongfang.87bd33eb.jpg";